'use client';

import dynamic from 'next/dynamic';
import { normalizeLocale } from '@/i18n/config';
import translations from '@/i18n/marketing-showcase-copy.json';
import { ShowcaseCarousel } from '../landing-showcase-carousel';
import { ShowcaseCopyContext } from './translation';
import './styles.css';

// Each scene is mounted only while its outer slide is selected. The original
// in-view clocks and reduced-motion behavior remain inside the recovered scenes.
const CollectionAnimation = dynamic(() =>
  import('./scenes').then((m) => m.CollectionAnimation)
);
const ProductionAnimation = dynamic(() =>
  import('./scenes').then((m) => m.ProductionAnimation)
);
const DeliverablesAnimation = dynamic(() =>
  import('./scenes').then((m) => m.DeliverablesAnimation)
);
const SellMarketAnimation = dynamic(() =>
  import('./scenes').then((m) => m.SellMarketAnimation)
);

export function CollectionShowcase({
  locale,
  label,
  controls,
}: {
  locale: string;
  label: string;
  controls: { previous: string; next: string };
}) {
  const copy = translations[normalizeLocale(locale)];
  return (
    <ShowcaseCopyContext value={copy}>
      <ShowcaseCarousel
        label={label}
        roleDescription={copy.carousel}
        previousLabel={controls.previous}
        nextLabel={controls.next}
        slides={[
          {
            id: 'collection',
            label: copy['Plan & Design Collections'],
            content: (
              <div className="collection-showcase">
                <CollectionAnimation />
              </div>
            ),
          },
          {
            id: 'production',
            label: copy['From Approvals to Manufacturing'],
            content: (
              <div className="collection-showcase">
                <ProductionAnimation />
              </div>
            ),
          },
          {
            id: 'deliverables',
            label: copy['One System of Record'],
            content: (
              <div className="collection-showcase">
                <DeliverablesAnimation />
              </div>
            ),
          },
          {
            id: 'sell-market',
            label: copy['Marketing & Launch'],
            content: (
              <div className="collection-showcase">
                <SellMarketAnimation />
              </div>
            ),
          },
        ]}
      />
    </ShowcaseCopyContext>
  );
}
